import { render } from "./request-password.vue?vue&type=template&id=7bb0af1a"
import script from "./request-password.vue?vue&type=script&lang=js"
export * from "./request-password.vue?vue&type=script&lang=js"

import "./request-password.vue?vue&type=style&index=0&id=7bb0af1a&lang=scss"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__